import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {orderVerificationTableReady,rowsPerPageState,searchTextState,paginationState,orderVerificationIdForAction,previousFilterStartDate,previousFilterEndDate,previousFilterCity,previousFilterStatus,previousFilterKitchen,previousFilterStore} from '../redux/order_verification'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import * as Helpers from '../../../common/helpers'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/order_verificationTable.css'

import {StoresComboList} from './DropDowns/index'

import { CSVLink } from 'react-csv'
import { createXLSheetdata } from '../services/helpers'

import DateRangePicker from 'react-bootstrap-daterangepicker'
import 'react-bootstrap-daterangepicker/css/daterangepicker.css'
import moment from 'moment'


import {  AddWeight } from './ActionButtons'



import CollapsibleProductsRow from './CollapsibleProductsRow'


import {Kitchens,Cities,EntityStatus} from '../../../common/DropDowns/index'

// function filterExportData (orderVerificationData){
//     let array = orderVerificationData

//     let newArray = []
//     if (array.length > 0) {
//         for (let i = 0; i < array.length; i++) { 

//             if(array[i].menu_ticket_details.length>0){
                

//                 for (let j=0; j<array[i].menu_ticket_details.length; j++) {
//                         let temp ={}

//                         temp.id = array[i].id
//                         temp.store_name =  array[i].store_name
//                         temp.kitchen_name =  array[i].kitchen_name
//                         temp.menu_name =  array[i].menu_name 
//                         temp.created =    array[i].created         
//                         temp.type =  array[i].type
//                         temp.platform =  array[i].platform
//                         temp.status =  array[i].status
//                         temp.remarks =  array[i].remarks
//                         temp.reason_name =   array[i].reason_name
//                         temp.city_name = array[i].city_name
//                         temp.resolver_name=array[i].resolver_name

//                         temp.product_remarks=array[i].menu_ticket_details[j]['remarks']
//                         temp.product_reason=array[i].menu_ticket_details[j]['reason']
//                         temp.product_name=array[i].menu_ticket_details[j]['product']
//                         temp.product_sku=array[i].menu_ticket_details[j]['sku']
//                         newArray.push(temp)             
//                     }   
//             }else{
//                 newArray.push(array[i])
//             }  
            
//         }
//     }
//     return newArray
// }

function filterUnwantedData(orderVerificationData) {
    let array = []
    if (orderVerificationData && orderVerificationData.data && orderVerificationData.data.list) {
        array = orderVerificationData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.partner_order_id = lineData.partner_order_id ? lineData.partner_order_id : ""
            newLineData.partner_status = lineData.partner_status  ? lineData.partner_status : ""
            newLineData.status = lineData.status ? lineData.status : ""
            newLineData.actual_weight = lineData.actual_weight ? lineData.actual_weight : ""


           
            newLineData.store_name = lineData.store && lineData.store.name ? lineData.store.name : ""

            newLineData.kitchen_name = lineData.store && lineData.store && lineData.store.kitchen && lineData.store.kitchen.name ? lineData.store.kitchen.code+" - "+lineData.store.kitchen.name : ""


            newLineData.city_name = lineData.store && lineData.store.kitchen && lineData.store.kitchen.city && lineData.store.kitchen.city.name ? lineData.store.kitchen.city.name : ""

           

            newLineData.created = lineData.created ? Helpers.getDateTimeFormatForUTC(lineData.created) : "NA"  
            
            newLineData.modified =lineData.modified ? Helpers.getDateTimeFormatForUTC(lineData.modified) : "" 

            if(lineData.modified_details.length>0){
            let modified_data=lineData.modified_details[0]

            newLineData.verified_by=modified_data && modified_data.modified_user && modified_data.modified_user.modified_employee_profile && modified_data.modified_user.modified_employee_profile.name ? modified_data.modified_user.modified_employee_profile.name +" - "+modified_data.modified_user.modified_employee_profile.code : ""         

            }

            let line_items=[]
            //newLineData.weight_flag=false;
            newLineData.gross_weight=0

            for (let j = lineData.line_items.length - 1; j>= 0; j--) {

                // if(lineData.line_items[j]['weight']===0){
                //     newLineData.weight_flag=true;
                // }

                newLineData.gross_weight+=lineData.line_items[j]['weight']*lineData.line_items[j]['quantity']

                let obj={
                    "id":lineData.line_items[j]['id'],
                    "partner_menu_id":lineData.line_items[j]['partner_menu_id'],
                    "quantity":lineData.line_items[j]['quantity'],
                    "menu_id":lineData.line_items[j]['menu_id'],
                    "weight":lineData.line_items[j]['weight'],
                    "menu_name":lineData.line_items[j]['menu'] && lineData.line_items[j]['menu']['name'] ? lineData.line_items[j]['menu']['name'] : ""
                }
                line_items.push(obj);
            }


            newLineData.line_items=line_items     
            newArray[i] = newLineData
        }
    }
    return newArray
}


class OrderVerificationTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            orderVerificationData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            filter_status:"",
            filter_kitchen_id:"",
            filter_city_id:"",
            storeSelectedId:0,
            startDate: moment().format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            ranges: {
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                'Yesterday': [moment().subtract(1, 'day'), moment().subtract(1, 'day')]
            },
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
            
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null
        this.CSVData = []
        this.createCSVData = this.createCSVData.bind(this)
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(orderVerificationTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.ORDER_VERIFICATION_TABLE))
        this.props.dispatch(subHeaderDataUpdate())

        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()


            let previousFilterStartDate=moment().format("YYYY-MM-DD")
            let previousFilterEndDate=moment().format("YYYY-MM-DD")
            let previousFilterStatus=""
            let previousFilterCity=""
            let previousFilterKitchen=""
            let previousFilterStore=0

         if (this.props.order_verification && this.props.order_verification.previousFilterStartDate && this.props.order_verification.previousFilterStartDate!==undefined) {
            previousFilterStartDate=this.props.order_verification.previousFilterStartDate
         }
         if (this.props.order_verification && this.props.order_verification.previousFilterEndDate && this.props.order_verification.previousFilterEndDate!==undefined) {
            previousFilterEndDate=this.props.order_verification.previousFilterEndDate
         }
         if (this.props.order_verification && this.props.order_verification.previousFilterStatus && this.props.order_verification.previousFilterStatus!==undefined) {
            previousFilterStatus=this.props.order_verification.previousFilterStatus
         }
         if (this.props.order_verification && this.props.order_verification.previousFilterCity && this.props.order_verification.previousFilterCity!==undefined) {
            previousFilterCity=this.props.order_verification.previousFilterCity
         }
         if (this.props.order_verification && this.props.order_verification.previousFilterKitchen && this.props.order_verification.previousFilterKitchen!==undefined) {
            previousFilterKitchen=this.props.order_verification.previousFilterKitchen
         }
         if (this.props.order_verification && this.props.order_verification.previousFilterStore && this.props.order_verification.previousFilterStore!==undefined) {
            previousFilterStore=this.props.order_verification.previousFilterStore
         }

         
         this.setState({
              filter_status:previousFilterStatus,
              filter_kitchen_id:previousFilterKitchen,
              filter_city_id:previousFilterCity,
              storeSelectedId:previousFilterStore,
              startDate:previousFilterStartDate,
              endDate:previousFilterEndDate
         },() => {
            this.getOrderVerificationData();
        });    
        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 280) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }


     onApplyEvent = (event, picker) => {
        let startDate = moment(picker.startDate)
        let endDate = moment(picker.endDate)

        let api_start_date=moment(picker.startDate).format("YYYY-MM-DD")
        let api_end_date=moment(picker.endDate).format("YYYY-MM-DD")
        if (endDate.diff(endDate, 'months', true) > 1) {
            this.dialog.show({
                title: "Date chosen is greater than one month",
                body: 'Please choose any Dates within one month and then try again',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        } else {
            if (startDate.isAfter(moment().add(1, 'days')) ||
                endDate.isAfter(moment().add(1, 'days'))) {
                this.dialog.show({
                    title: "Date Chosen is greater than current date",
                    body: 'Please choose any Dates within current date and then try again',
                    actions: [
                        Dialog.OKAction(() => {
                        })
                    ],
                })
            } else {

                this.props.dispatch(previousFilterStartDate(api_start_date))
                this.props.dispatch(previousFilterEndDate(api_end_date))

                this.setState({
                    startDate: api_start_date,
                    endDate: api_end_date
                })
            }
        }
    }
    
    getOrderVerificationData = () => {
        apiService.getOrderVerificationData(this.state.startDate,this.state.endDate,this.state.storeSelectedId,this.state.filter_status,this.state.filter_kitchen_id,this.state.filter_city_id)
            .then(orderVerificationData => {
                if (orderVerificationData && this.isComponentMounted) {
                    this.validateBuildNumber(orderVerificationData)
                    if (orderVerificationData.status === "SUCCESS") {
                        let array = filterUnwantedData(orderVerificationData), pageNo = 1
                        if (this.props.order_verification && this.props.order_verification.previousPaginationValue) {
                            pageNo = this.props.order_verification.previousPaginationValue
                        }
                        this.setState({
                            orderVerificationData: array,
                            page: pageNo,
                        })


                        // let exportData=filterExportData(array)

                        // this.createCSVData(exportData)
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: orderVerificationData.reason ? orderVerificationData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(orderVerificationTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(orderVerificationTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    

    

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.order_verification && this.props.order_verification.previousRowsPerPageValue) {
            value = this.props.order_verification.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }



    renderReasonRemarks = (cell, row, enumObject, rowIndex,) => {
        
        let reason=""
        if(row.reason_name && row.reason_name!=="" && row.reason_name!==undefined){
        
            reason=<p>{row.reason_name}<br/>({row.remarks})</p>
        }
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{reason}</div>
        </div>)
    }


    createCSVData(csvData) {
        let ticketList = []
        if (csvData) {
            ticketList = JSON.parse(JSON.stringify(csvData))
            ticketList = createXLSheetdata(ticketList)
        }
        this.CSVData = ticketList
    }



    kitchenChange = (data) => {

       
        if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterKitchen(""))
             this.setState({
                filter_kitchen_id :"",            
            })
        }else{
            this.props.dispatch(previousFilterKitchen(data.value))
             this.setState({
            filter_kitchen_id :data.value,
            
        })
        }
    }
    cityChange = (data) => {

        
        if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterCity(""))
              this.setState({
                filter_city_id :"",            
            })
        }else{
            this.props.dispatch(previousFilterCity(data.value))
            this.setState({
            filter_city_id :data.value,
            
            })
        }
    }
    storeChange = (data) => {

        
        if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterStore(""))
             this.setState({
                storeSelectedId :0            
            })
        }else{
            this.props.dispatch(previousFilterStore(data.value))
            this.setState({
            storeSelectedId :data.value,
            
        })
        }
    }

    

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

     renderLocation = (cell, row, enumObject, rowIndex,) => {
        
        let location=""
        
            location=<p>{row.work_location} - {row.city_name}</p>

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{location}</div>
        </div>)
    }


   entityStatusChange = (data) => {
        if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterStatus(""))
             this.setState({
                filter_status :"",            
            })
        }else{
            this.props.dispatch(previousFilterStatus(data.value))
            this.setState({
                filter_status :data.value,            
            })
        }
    }




    renderCreatedFormat = (cell, row, enumObject, rowIndex,) => {
                let dateTemp="NA"

        if(row.created){
            dateTemp=Helpers.getDateTimeFormatForUTC(row.created)
        }
        
         
        return (<p>{dateTemp}</p>)
    }



     expandComponent = row => {
        let row_id = ""
        if (row && row.id) {
            row_id = row.id
        }
        return <CollapsibleProductsRow row={row} row_id={row_id}/>
    }

    isExpandableRow = row => {
        return true
    }


    expandColumnComponent = ({ isExpandableRow, isExpanded }) => {
        let downIconClassName = ""
        if (isExpandableRow) {
            downIconClassName = (isExpanded ? 'fa fa-angle-double-up' : 'fa fa-angle-double-down')
        } else {
            downIconClassName = ""
        }
        return (
            <div className="custom-expandable-row-indicator">
                <span className={downIconClassName} />
            </div>
        )
    }





   

    createCustomToolBar = props => {


        let ticketDetailsFilename = "orderVerification" + moment().format("MM/DD/YYYY") + "-" +
            moment().format("h:mm:ss") + ".csv"


        let startDate = "", endDate = "", start = "", end = "", label = ""

        startDate = moment(this.state.startDate)
        endDate = moment(this.state.endDate)

        start = moment(startDate).format('DD-MM-YYYY')
        end = moment(endDate).format('DD-MM-YYYY')

        label = start + ' to ' + end;

        if (start === end) {
            label = start
        }

        let firstComponent = ''

        
            firstComponent = <div className="col-md-3 col-sm-12 col-xs-12 div-margins">
                <div className="form-group">
                    <DateRangePicker startDate={startDate}
                        endDate={endDate}
                        ranges={this.state.ranges}
                        showDropdowns={true}
                        onApply={this.onApplyEvent}>
                        <button className="date-picker-button">
                            <div className="pull-left"><i className="fa fa-calendar" /></div>
                            <span style={{ textAlign: 'center' }}>{label}</span>
                            <div className="pull-right">
                                <span className="caret"></span>
                            </div>
                        </button>
                    </DateRangePicker>
                </div>
            </div>


        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">


                    {firstComponent}


                     {(() => {
                        if(Helpers.checkPrivileges("/root/filter",this.props.user)){
                            return (

                   
                   <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                        <div className="form-group">
                            <Cities cityChange={this.cityChange} selectedValue={this.state.filter_city_id} />   
                        </div>
                    </div>

                         )
                        }
                    })()}

                     {(() => {
                        if(this.state.filter_city_id && this.state.filter_city_id!=="" && this.state.filter_city_id!==undefined){
                            return(
                           <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                            <div className="form-group">
                                <Kitchens kitchenChange={this.kitchenChange} selectedCity={this.state.filter_city_id} selectedValue={this.state.filter_kitchen_id} />   
                            </div>
                            </div>
                            )
                        }
                    })()}

                    {(() => {
                        if(this.state.filter_kitchen_id && this.state.filter_kitchen_id!=="" && this.state.filter_kitchen_id!==undefined){
                            return(

                   <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                    <div className="form-group">
                        <StoresComboList storeChange={this.storeChange} selectedKitchen={this.state.filter_kitchen_id} selectedValue={this.state.storeSelectedId} />    
                    </div>
                    </div>
                    )
                        }
                    })()}
                   
                   
                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>

                <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8 header-div-margins">


                    <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                        <div className="form-group">
                                   <EntityStatus type="ORDER_VERIFICATION" entityStatusChange={this.entityStatusChange} selectedValue={this.state.filter_status} />    
                                </div>
                    </div>
                   <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                        <button className="btn btn-primary button-custom"
                            onClick={(e) => {
                                e.preventDefault()
                                this.getFilteredorderVerificationList()
                            }}>
                            Go
                        </button>
                        <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                this.resetFilterValues()
                            }}>
                            Clear
                        </button>
                    
                        <CSVLink
                            data={this.CSVData}
                            className="btn btn-primary button-custom"
                            style={{ marginLeft: "10px",background: "#3c8dbc",border:"1px solid #3c8dbc"}}
                            filename={ticketDetailsFilename}>
                            Export
                        </CSVLink>
                     
                    </div>

                </div>
            </div>
        )
    }
   
   createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.orderVerificationData.length>=(this.props.order_verification.previousPaginationValue*this.props.order_verification.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.order_verification.previousPaginationValue*this.props.order_verification.previousRowsPerPageValue)-this.props.order_verification.previousRowsPerPageValue+1} to {this.props.order_verification.previousPaginationValue*this.props.order_verification.previousRowsPerPageValue} of {this.state.orderVerificationData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.order_verification.previousPaginationValue*this.props.order_verification.previousRowsPerPageValue)-this.props.order_verification.previousRowsPerPageValue+1} to {this.state.orderVerificationData.length} of {this.state.orderVerificationData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }


    getFilteredorderVerificationList = () => {
       
        this.props.dispatch(orderVerificationTableReady(false))
        this.resetSearchAndPagination()
        this.getOrderVerificationData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }


updateTicket= (row) =>{

    if (row && row.id) {
            this.props.dispatch(orderVerificationIdForAction(row.id))
            this.props.history.push("/dashboard/orderVerification/update")
        } else {
            this.dialog.show({
                title: "Order Verification Identification number not found",
                body: 'Order Verification id is not available, So not able edit menu ticket',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    
}



    addBtnCreator = (cell, row, enumObject, rowIndex) => {
        //debugger;
        

        let addBtn=""



        if(row.status==="NEW"){

        if(Helpers.checkPrivileges("/dashboard/orderVerification/update",this.props.user)){
            addBtn =<button
                    className="action-button"
                    style={{marginBottom: "1px" }}
                    onClick={(e) => {
                        e.preventDefault()
                        this.updateTicket(row)
                    }}>
                    <i className="fa fa-pencil-square-o" aria-hidden="true"></i> Edit
                </button>
        }
        }
         
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{addBtn} </div>
        </div>)
    }




 renderVerified = (cell, row, enumObject, rowIndex) => {
        //debugger;
        let verified_by=""

        if(row.status==="VERIFIED"){
            verified_by=<p>{row.verified_by}<br/>{row.modified}</p>
        }
        
         
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{verified_by} </div>
        </div>)
    }


    statusRender = (cell, row, enumObject, rowIndex) => {
        //debugger;
        
        let statusBtn=<p>{row.status}</p>
         
        return (<div className={"row order_verification_status_"+row.status.split(" ").join("_")+""}>
            <div className="col-md-12 col-sm-12 col-xs-12">{statusBtn} </div>
        </div>)
    }


    renderEditAction = (cell, row) => {
        let editButton =""


        if(Helpers.checkPrivileges("/dashboard/orderVerification/addEdit",this.props.user) && row.status==="NEW" ){
        
            editButton=<AddWeight data={row}/>
        }

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{editButton}</div>
        </div>)
    }

    

    resetFilterValues = () => {
        this.props.dispatch(orderVerificationTableReady(false))
        this.setState({
            startDate: moment().format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            filter_status:"",
            filter_kitchen_id:"",
            filter_city_id:"",
            filter_platform:"",
            storeSelectedId:0
        },() => {
             this.resetPagination()
        
            this.props.dispatch(searchTextState(""))
            this.searchBox.wrappedInstance.refs.searchInput.value = ""
            this.searchBox.props.search("")

            this.props.dispatch(previousFilterCity(""))
            this.props.dispatch(previousFilterStatus(""))
            this.props.dispatch(previousFilterKitchen(""))
            this.props.dispatch(previousFilterStore(""))
            this.props.dispatch(previousFilterStartDate(moment().format("YYYY-MM-DD")))
            this.props.dispatch(previousFilterEndDate(moment().format("YYYY-MM-DD")))

        this.getOrderVerificationData();
        });
    }


 

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.order_verification && this.props.order_verification.previousPaginationValue
            && this.props.order_verification.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }

    editorderVerification = (row) => {
        if (row && row.id) {
            this.props.dispatch(orderVerificationIdForAction(row.id))
            this.props.history.push("/dashboard/order_verification/order_verificationtickets/addEdit")
        } else {
            this.dialog.show({
                title: "orderVerification Identification number not found",
                body: 'orderVerification id is not available, So not able edit brand',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }

    render() {
        let sizeperPage = 15

        if (this.props.order_verification && this.props.order_verification.previousRowsPerPageValue) {
            sizeperPage = this.props.order_verification.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
             <div className="orderVerification-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>                

                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.orderVerificationData}
                    pagination={true}
                    expandableRow={this.isExpandableRow}
                    expandComponent={this.expandComponent}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight}}
                    expandColumnOptions={{
                        expandColumnVisible: true,
                        rerenderOnDataChange: true,
                        expandColumnComponent: this.expandColumnComponent
                    }}>

                     {(() =>{
                        if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
                                return(  
                    
                    <TableHeaderColumn
                        dataField="id"
                        isKey={true}
                        expandable={false}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Id
                    </TableHeaderColumn>

                    )
                }else{
                    return(
                         <TableHeaderColumn
                        dataField="id"
                        isKey={true}
                        expandable={false}
                        hidden={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Id
                    </TableHeaderColumn>
                    )
                }
            })()}



                    <TableHeaderColumn
                        dataField="partner_order_id"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Order Id 
                    </TableHeaderColumn>            
                    
                    <TableHeaderColumn
                        dataField="kitchen_name"
                         dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Kitchen
                    </TableHeaderColumn>               
                    
                    <TableHeaderColumn
                        dataField="store_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Store
                    </TableHeaderColumn>    
                    
                    <TableHeaderColumn
                        dataField="city_name"
                         dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       City
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="partner_status"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Partner Status
                    </TableHeaderColumn> 

                    <TableHeaderColumn
                        dataField="gross_weight"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Gross Weight
                    </TableHeaderColumn> 
                    <TableHeaderColumn
                        dataField="actual_weight"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Actual Weight

                    </TableHeaderColumn> 

                      <TableHeaderColumn
                        dataFormat={this.statusRender}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Status
                    </TableHeaderColumn> 


                {/*

                   
                    
                    <TableHeaderColumn
                        dataField="resolver_name"
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Resovled By
                    </TableHeaderColumn>

                    */}

                    <TableHeaderColumn
                        dataField="created"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Created
                    </TableHeaderColumn>


                    <TableHeaderColumn
                        dataFormat={this.renderVerified}
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Verified By
                    </TableHeaderColumn>   

                    <TableHeaderColumn
                        //dataField="reason_name"
                        dataFormat={this.renderEditAction}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Action
                    </TableHeaderColumn>


                    
      
                    
                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        order_verification: state.order_verification
    }
}

export default connect(mapStateToProps)(withRouter(OrderVerificationTable))


// WEBPACK FOOTER //
// ./src/modules/Order Verification/Components/OrderVerificationTable.js